import { ActivityIndicator, Dimensions, FlatList, Image, Modal, PixelRatio, ScrollView, StyleSheet, Text, View } from 'react-native'
import * as ImagePicker from 'expo-image-picker';
import * as FileSystem from 'expo-file-system';
import React, { useEffect, useState } from 'react'
import { TouchableOpacity } from 'react-native'
import Colours from '../../utils/Colours';
import ErrorAlertComp from '../../alertComp/ErrorAlertComp';
import SuccessAlertComp from '../../alertComp/SuccessAlertComp';
import PostToPullandTable from './PostToPullandTable';
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent';


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const MAX_IMAGES = 2;
const MAX_IMAGE_SIZE_MB = 65;

const PostingPicturePage = ({ setShowPostingPicture }) => {
    // const [image, setImage] = useState(null)
    const [images, setImages] = useState([])
    const [isPhotoClicked, setIsPhotoClicked] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoading1, setIsLoading1] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const [isLoading3, setIsLoading3] = useState(false)
    const [isSendPhotoClicked, setIsSendPhotoClicked] = useState(false)
    const [selectedPhoto, setSelectedPhoto] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [postToPullandTable, setShowPostToPullandTable] = useState(false)


    useEffect(() => {
        //console.log('images', images)
    }, [])

    const pickMultiImage = async (setImages, currentImages) => {
        try {
            setIsLoading(true);

            const result = await ImagePicker.launchImageLibraryAsync({
                mediaTypes: ['images'],
                allowsEditing: false,
                allowsMultipleSelection: true,
                aspect: [4, 4],
                quality: 1,
            });

            if (result.canceled) return;

            const newAssets = result.assets || [];
            const newImageURIs = [];

            for (let asset of newAssets) {
                const fileInfo = await FileSystem.getInfoAsync(asset.uri);
                const fileSizeInMB = fileInfo.size / (1024 * 1024);

                //console.log(`Selected image size: ${fileSizeInMB.toFixed(2)} MB`);

                if (fileSizeInMB > MAX_IMAGE_SIZE_MB) {
                    setErrorMessage(
                        `Image too large: The selected image is ${fileSizeInMB.toFixed(
                            2
                        )} MB. Please choose one below.`
                    );
                    setIsErrorCompVisible(true);
                    setSelectedPhoto(false);
                    setIsLoading(false);
                    return; // Stop processing if any image is too large
                }

                newImageURIs.push(asset.uri);
            }

            const totalImages = [...currentImages, ...newImageURIs];

            if (totalImages.length > MAX_IMAGES) {
                setErrorMessage(`You can only select up to ${MAX_IMAGES} images.`);
                setIsErrorCompVisible(true);
                setImages(currentImages); // Keep the previous state unchanged
                setSelectedPhoto(true);
            } else {
                setImages(totalImages);
                setSelectedPhoto(true);
            }

        } catch (error) {
            //console.error('Error picking image:', error);
            setErrorMessage('An error occurred while selecting images.');
            setIsErrorCompVisible(true);
        } finally {
            setIsLoading(false);
        }
    };


    const handleSendPhoto = async () => {
        setShowPostToPullandTable(true)
    }
    const handleChangeImage = async () => {

    }

    return (
        <ScrollView
            style={styles.componentStyle}
            contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
            showsVerticalScrollIndicator={false}
        >
            <View>

                <TouchableOpacity
                    style={[styles.photoViewStyle, isPhotoClicked && styles.focusedBorder]}
                    onPress={() => pickMultiImage(setImages, images)}
                    onPressIn={() => setIsPhotoClicked(true)}
                    onPressOut={() => setIsPhotoClicked(false)}
                >

                    {isLoading ? (<View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
                    </View>
                    ) : (
                        <>
                            <Text style={styles.photoTxt}>Select Photos:</Text>

                            {images && images.length > 0 ? (
                                // <Image style={styles.imageStyle} source={{ uri: image }} />
                                <FlatList
                                    data={images}
                                    horizontal
                                    // keyExtractor={(item) => item._id.toString()}
                                    keyExtractor={(item, index) => item + index}
                                    renderItem={({ item, index }) => (
                                        isLoading3[index] ? (
                                            <View style={styles.imageStyle}>
                                                <ActivityIndicator size="small" color={Colours.PRIMARY} />
                                            </View>
                                        ) : (
                                            <TouchableOpacity
                                                onPress={() => {

                                                    handleChangeImage(index);

                                                }}
                                            >
                                                <Image
                                                    style={styles.imageStyle}
                                                    source={{ uri: item }}
                                                />
                                            </TouchableOpacity>
                                        )
                                    )}
                                />
                            ) : (
                                <Image style={styles.imageStyle} source={require('../../../assets/imagePlaceholder.jpg')} />
                            )}
                        </>
                    )}
                </TouchableOpacity>

                <TouchableOpacity style={[styles.sendPhotoButton, {

                    backgroundColor: isSendPhotoClicked ? Colours.PRIMARY : Colours.DARKGRAY,
                    opacity: selectedPhoto ? 1 : 0.5,
                }]}
                    onPress={handleSendPhoto}
                    disabled={!selectedPhoto}
                >
                    {isLoading2 ? (
                        <ActivityIndicator size="small" color="white" />
                    ) : (
                        <Text style={styles.openCreatTxt}>
                            Send
                        </Text>
                    )}
                </TouchableOpacity>

                {/* <Modal
                    visible={isSuccessAlertCompVisible}
                    transparent={true}
                    animationType="fade"
                >
                    <SuccessAlertComp
                        message={successMessage}
                        onClose={handleCloseModal}
                    />
                </Modal> */}
                <Modal
                    visible={isErrorCompVisible}
                    transparent={true}
                    animationType="fade"
                    onRequestClose={() => setIsErrorCompVisible(false)}
                >
                    <ErrorAlertComp
                        message={errorMessage}
                        onClose={() => setIsErrorCompVisible(false)}
                    />
                </Modal>
                <Modal
                    animationType='slide'
                    visible={postToPullandTable}
                    onRequestClose={() => setShowPostToPullandTable(false)}
                >
                    <TopHeaderComponent headerText={"Send to"} hideScreen={() => setShowPostToPullandTable(false)} />
                    <View style={{ backgroundColor: Colours.LIGHTEST }}>
                        <PostToPullandTable
                            image={images}
                            setShowPostToPullandTable={setShowPostToPullandTable}
                            setShowPostingPicture={setShowPostingPicture}

                        />
                    </View>
                </Modal>
            </View>
        </ScrollView>
    )
}

export default PostingPicturePage

const styles = StyleSheet.create({
    componentStyle: {
        backgroundColor: Colours.LIGHTEST,
        display: 'flex',
        // margin: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        //borderRadius: dynamicSize(15),
        height: '100%',
    },
    photoViewStyle: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: dynamicSize(60),
        width: '100%',
        marginTop: dynamicSpacing(10),
        paddingLeft: dynamicSpacing(10),
        paddingRight: dynamicSpacing(10),
        borderWidth: dynamicSize(2),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(10),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        marginBottom: dynamicSpacing(5),
        backgroundColor: Colours.LIGHTGRAY,
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    photoTxt: {
        marginRight: dynamicSpacing(100),
        color: Colours.DARKLIGHTGRAY,
        fontSize: dynamicFontSize(15),
        fontFamily: 'Sen-Regular',

    },
    imageStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: dynamicSize(45),
        height: dynamicSize(40),
        borderRadius: dynamicSize(10),
        marginLeft: dynamicSpacing(5)
    },
    sendPhotoButton: {
        display: 'flex',
        borderRadius: dynamicSize(10),
        justifyContent: 'center',
        marginTop: dynamicSpacing(10),
        alignItems: 'center',
        height: dynamicSize(55),
        width: '100%',
        backgroundColor: Colours.DARKGRAY,
    },
    openCreatTxt: {
        fontSize: dynamicFontSize(15),
        color: 'white',
        fontFamily: 'Sen-Bold',
    },

})